import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import {getToken, removeToken} from '@/common/auth'
import router from "@/router";

// import { Loading } from 'element-ui'
// import vue from "vue";

// let loadingRequestCount = 0
// let loadingInstance
// const showLoading = () => {
//   if (loadingRequestCount === 0) {
//     // element的服务方式 target 这边取的是表格
//     // 和在表格配置v-loading一样的效果，这么做是全局实现了，不用每个页面单独去v-loading
//     loadingInstance = Loading.service({ target: '.el-table' })
//   }
//   loadingRequestCount++
// }
//
// const hideLoading = () => {
//   if (loadingRequestCount <= 0) return
//   loadingRequestCount--
//   if (loadingRequestCount === 0) {
//     // vue.$nextTick(()=>{//以服务的方式调用的 Loading 需要异步关闭
//     loadingInstance.close()
//     // });
//   }
// }
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['Authorization'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = getToken()

      // 请求拦截进来调用显示loading效果
      // showLoading(config)
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  res => {
    if (res.status === 200) {
      const responseData = res.data
      if (responseData.code === 200) {
        return Promise.resolve(responseData)
      }
      if (responseData.code === 401){
        Message.error(responseData.msg)
        location.reload();
      } else {
        if (res.config.url==='/api/login'){
          store.dispatch('user/errData', res.data.msg)
        } else {
          // Message.error(responseData.msg?responseData.msg:'网络连接失败, 请稍后重试')

        }
      }
    } else {
      Message.error('网络连接失败, 请稍后重试')
    }
    return Promise.reject(res.data)



    // const res = response.data
    //
    // // if the custom code is not 200, it is judged as an error.
    // if (res.code !== 200) {
    //   Message({
    //     message: res.msg || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   // setTimeout(() => {
    //   //   hideLoading()
    //   // }, 100)
    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.msg || 'Error'))
    // } else {
    //   // setTimeout(() => {
    //   //   hideLoading()
    //   // }, 100)
    //   return res
    // }



  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          removeToken()
          router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
          break
        case 403:
          Message.error('登录过期，请重新登录')
          removeToken()
          setTimeout(() => router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } }), 1000)
          break
        case 404:
          Message.error('网络请求不存在')
          break
        case 502:
          Message.error('服务器开小差，请稍后重试')
          break
        case 500:
          Message.error('服务器开小差，请稍后重试')
          break
        default:
          Message.error(error.response.data.data.msg)
      }
      return Promise.reject(error.response.data)
    }
    // console.log('err' + error) // for debug
    // Message({
    //   // message: error.message,
    //   message: error.message === 'Request failed with status code 500' ? '网络出错,请稍后重试！！' : error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    // return Promise.reject(error)
  }
)

export default service
